import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/../environments/environment';
import { EditalCondicaoEspecial, EditalCondicaoEspecialRequest } from '@/models';

@Injectable({
  providedIn: 'root',
})
export class EditalCondicaoEspecialService {
  private baseUrl = `${environment.apiUrl}/admin/editais`;

  constructor(private http: HttpClient) {}

  getCondicoesEspeciaisAtivas(editalId: number): Observable<EditalCondicaoEspecial[]> {
    return this.http.get<EditalCondicaoEspecial[]>(`${this.baseUrl}/${editalId}/condicoes-especiais/ativas`);
  }

  vincularCondicaoEspecial(editalId: number, data: EditalCondicaoEspecialRequest): Observable<EditalCondicaoEspecial> {
    return this.http.post<EditalCondicaoEspecial>(`${this.baseUrl}/${editalId}/condicoes-especiais`, data);
  }

  removerCondicaoEspecial(editalId: number, editalCondicaoEspecialId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${editalId}/condicoes-especiais/${editalCondicaoEspecialId}`);
  }
}
